// components/SummarySection.tsx
import { FC } from 'react';
import { SummarySectionType } from '../../models/bot';
import SummaryRow from './summary-row';

const SummarySection: FC<SummarySectionType> = ({ title, rows }) => (
  <div className="bot-summary__section">
    {title && <div className="bot-summary__section-title">{title}</div>}
    <div className="bot-summary__rows">
      {rows.map((row, idx) => (
        <SummaryRow key={`${title}-${row.label}-${idx}`} {...row} />
      ))}
    </div>
  </div>
);

export default SummarySection;
